module.exports = __webpack_public_path__ + "img/photo05_sp.f6112a6f.jpg";